import {Component} from '@angular/core';
import {IonicPage, LoadingController, NavController, NavParams} from 'ionic-angular';
import {IonicSelectableComponent} from 'ionic-selectable';

import {ValidatorProvider} from '../../providers/validator/validator';
import {AlertProvider} from '../../providers/alert/alert';
import {AuthProvider} from '../../providers/auth/auth';
import {NetworkMonitorProvider} from '../../providers/network-monitor/network-monitor';
import {EventEmitterProvider} from '../../providers/event-emitter/event-emitter';

import {RegistrationDocument} from '../../models/registrationdocument';

/**
 * Generated class for the UpdateRegistrationDocumentPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */
@IonicPage()
@Component({
  selector: 'page-update-registration-document',
  templateUrl: 'update-registration-document.html',
})
export class UpdateRegistrationDocumentPage {

  private user: any;
  public registrationDocument: RegistrationDocument;
  public documentKinds: any[];
  public scholarities: any[];

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private alertProvider: AlertProvider,
    private loadingCtrl: LoadingController,
    private authProvider: AuthProvider,
    private validatorProvider: ValidatorProvider,
    private networkMonitorProvider: NetworkMonitorProvider,
    private eventEmitterProvider: EventEmitterProvider
  ) {
    this.registrationDocument = new RegistrationDocument();
    this.documentKinds = [
      {id: 'R', name: 'RG'},
      {id: 'C', name: 'CNH'},
      {id: 'I', name: 'Carteira de Identificação Profissional'},
      {id: 'P', name: 'Passaporte'},
      {id: 'T', name: 'Carteira Profissional'},
    ];
    this.scholarities = [
      {id: 'FI', name: 'Ensino Fundamental Incompleto'},
      {id: 'FC', name: 'Ensino Fundamental Completo'},
      {id: 'MI', name: 'Ensino Médio Incompleto'},
      {id: 'MC', name: 'Ensino Médio Completo'},
      {id: 'SI', name: 'Ensino Superior Incompleto'},
      {id: 'SC', name: 'Ensino Superior Completo'},
      {id: 'PI', name: 'Pós-graduação Incompleta'},
      {id: 'PC', name: 'Pós-graduação Completa'},
      {id: 'BI', name: 'MBA Incompleto'},
      {id: 'BC', name: 'MBA Completo'},
      {id: 'DO', name: 'Doutorado'},
    ];

    this.user = this.authProvider.getUser();
    if (this.user) {
      this.registrationDocument.federalCode = this.user.federalCode;
      this.registrationDocument.documentKind = this.user.documentKind;
      this.registrationDocument.documentCode = this.user.documentCode;
      this.registrationDocument.scholarity = this.user.scholarity;
    }
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad UpdateRegistrationDocumentPage');
  }

  onBack() {
    this.navCtrl.pop({
      animation: 'ios-transition'
    });
  }

  onDocumentKindChange(event: {
    component: IonicSelectableComponent,
    value: any
  }) {
    console.log('document kind:', event.value);
  }

  onScholarityChange(event: {
    component: IonicSelectableComponent,
    value: any
  }) {
    console.log('scholarity:', event.value);
  }

  doSave() {
    if (!this.networkMonitorProvider.isOnline()) {
      this.alertProvider.doAlert('É necessário estar conectado na Internet para salvar o documento.', 'Atenção');
    } else if (this.validatorProvider.isEmpty(this.registrationDocument.documentKind)) {
      this.alertProvider.doAlert('Forneça o tipo do documento.', 'Atenção');
    } else if (this.validatorProvider.isEmpty(this.registrationDocument.documentCode)) {
      this.alertProvider.doAlert('Forneça o número do documento.', 'Atenção');
    } else if (this.validatorProvider.isEmpty(this.registrationDocument.scholarity)) {
      this.alertProvider.doAlert('Forneça sua escolaridade.', 'Atenção');
    } else {
      let that = this;
      this.alertProvider.doConfirm('Deseja salvar seu documento?', () => {
        let loader = that.loadingCtrl.create({
          content: 'Enviando pedido...',
          // duration: 3000
        });
        loader.present();

        that.authProvider.updateDocument(that.registrationDocument).subscribe((response: any) => {
          if ((response) && (response.updated)) {
            that.alertProvider.doAlert('Seus dados pessoais foram salvos com sucesso.', 'Informação');
            loader.dismiss();

            // Update local user data
            that.user.documentKind = that.registrationDocument.documentKind;
            that.user.documentCode = that.registrationDocument.documentCode;
            that.user.scholarity = that.registrationDocument.scholarity;

            that.authProvider.setUser(that.user);
            that.eventEmitterProvider.get('registration_updated').emit(that.user);

            that.onBack();
          } else {
            loader.dismiss();
            that.alertProvider.doAlert('Houve problemas ao tentar salvar seu documento. Tente novamente mais tarde.', 'Atenção');
          }
        }, (error: any) => {
          console.log(error);
          loader.dismiss();
          that.alertProvider.doAlert('Houve problemas ao tentar salvar seu documento. Tente novamente mais tarde.', 'Atenção');
        });
      });
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/update-registration-document/update-registration-document.ts